import { z } from 'zod';

export const storeItemSchema = z.object({
    uri: z.string(),
    title: z.string(),
    price: z.number(),
    image: z.string(),
    license: z.boolean(),
});
export type StoreItem = z.infer<typeof storeItemSchema>;

export const storeFinalizeSchema = z.object({
    url: z.string(),
});
export type StoreFinalize = z.infer<typeof storeFinalizeSchema>;
